import makeStyles from '@mui/styles/makeStyles';
import {
  valueColor,
  buttonPurple,
  semiBoldFont,
  onInputHoverPurple,
  onInputFocusPurple,
  onHoverButtonPurple,
} from '../../../Styles/styles';

const addNewCustomerModalContentStyles = makeStyles(() => ({
  customerModalContentContainer: {
    paddingTop: '15px',
  },
  addCustomerModalFormControl: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${onInputHoverPurple}`,
    },
    '& .MuiInputBase-input:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: onInputFocusPurple,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        border: `1px solid ${onInputFocusPurple}`,
      },
    },
  },
  addCustomerModalDropdown: {
    height: '40px',
    width: '330px',
    '& div': {
      display: 'flex',
    },
  },
  addCustomerModalDropdownItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  addCustomerModalDropdownItemIconContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    '&:hover': {
      backgroundColor: 'lightsteelblue',
    },
  },
  addCustomerModalDropdownItemIcon: {
    color: 'darkslategray',
    fontSize: '15px',
  },
  addCustomerModalSectionDivider: {
    margin: '24px 0px',
  },
  addCustomerModalSectionHeader: {
    color: '#323547',
    fontSize: '20px',
    fontWeight: '600',
    letterSpacing: '0',
    lineHeight: '32px',
    fontFamily: semiBoldFont,
  },
  addCustomerModalSectionSubheader: {
    color: '#323547',
    fontSize: '14px',
    letterSpacing: '0',
    lineHeight: '20px',
    fontFamily: semiBoldFont,
    padding: '15px 0px 10px 0px',
  },
  addCustomerModalInputFieldContainer: {
    display: 'flex',
    margin: '20px auto',
    justifyContent: 'space-between',
    '& .MuiFormLabel-root.Mui-focused': {
      color: onInputFocusPurple,
    },
  },
  addCustomerModalInputField: {
    width: '100%',
    display: 'flex',
    fontSize: '14px',
    color: valueColor,
    lineHeight: '20px',
    alignItems: 'center',
    fontFamily: semiBoldFont,
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${onInputHoverPurple}`,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        border: `1px solid ${onInputFocusPurple}`,
      },
    },
  },
  addCustomerModalInputFieldWithButton: {
    width: '330px',
  },
  addCustomerModalInputFieldButtonContainer: {
    display: 'flex',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-end',
  },
  addCustomerModalInputFieldButton: {
    margin: '0px',
    width: '100%',
    borderRadius: '8px',
    color: buttonPurple,
    textTransform: 'none',
    maxWidth: 'fit-content',
  },
  addCustomerModalButtonsContainer: {
    display: 'flex',
    paddingTop: '26px',
    justifyContent: 'flex-end',
  },
  addCustomerModalCancelButton: {
    margin: '0px',
    width: '100%',
    borderRadius: '8px',
    color: buttonPurple,
    textTransform: 'none',
    maxWidth: 'fit-content',
  },
  addCustomerModalSaveButton: {
    color: 'white',
    padding: '6px 15px',
    borderRadius: '8px',
    textTransform: 'none',
    margin: '0px 0px 0px 12px',
    backgroundColor: buttonPurple,
    '&:disabled': {
      backgroundColor: '#E4E7EC',
      color: '#929FB4',
    },
    '&:hover': {
      color: 'white',
      backgroundColor: onHoverButtonPurple,
    },
  },
  customerFolderName: {
    marginRight: 'auto',
    marginLeft: '10px',
  },
  customerFolderIcon: {
    fontSize: '24px',
    color: 'slategray',
  },
}));

export default addNewCustomerModalContentStyles;
